import React, {useState} from 'react';
import { Google, Facebook, Or, Twitter, Logo } from "../../assets";
import "./Login.css";
import {Link, useHistory} from "react-router-dom";
import axios from 'axios';
import swal from "sweetalert";


const Login = () => {
  
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, setUser] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState({ value: "" });

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const user = { email, password };
    // send the username and password to the server
    // const response = await axios.post(
    //   "https://rewind-test.herokuapp.com/users/login",
    //   user
    // ).then(function (response) {
    //   setUser(response.data.user)
    // store the user in localStorage
    setUser(user);
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('user', JSON.stringify(user));
    // })
    // .catch(function (error) {
    //   setErrorMessage((prevState) => ({ value: "Invalid username/password", error }));
    // });
    
    // let userInfo = response.data
  };

  const history =useHistory();
  if (user) {
    swal({
      icon: 'success',
      title: "Success!",
      text: "Login Successful",
      type: "success",
      timer: 2000,
      showConfirmButton: false
    });
    // return <LandingPage user={user.props} handleLogout={handleLogout}/> ;
   history.push("/");
  }

  
  return (
    <>
      <main className="login-info">
        <section className="d-flex justify-content-center">
          <form className="mt-4 px-5 py-4" onSubmit={handleLogin}>
          <Link to="/" className="click" href="click">
            <img className="d-flex mx-auto" src={Logo} alt="" />
          </Link>
            <h1 className="login-header px-3">Sign In</h1>
            <p className="px-3 ">Welcome back, we missed you!</p>
            <label className="login-label mt-3">Email address</label>
            <input
              className="mb-3 login-input"
              name="email"
              // ref={register}
              type="email"
              value={email} 
              placeholder="Enter your email address"
              onChange={({ target }) => setEmail(target.value)}
            />

            <label className="login-label ml-4">Password</label>
            <input
              className="mb-4 login-input"
              name="password"
              // ref={register}
              type="password"
              value={password}
              placeholder="Enter your password"
              onChange={({ target }) => setPassword(target.value)}
            />
             {!isLoading ? <button
              className="d-block login-button "
              type="submit"
              value="Submit"
            >
              Sign In
            </button> :
             <button
             className="d-block login-button "
             type="submit"
             value="Submit"
           >
             Loading.....
           </button>
              }
            {errorMessage.value && (
          <p className="text-danger"> {errorMessage.value} </p>)}
            <p className="or-tag">
              <img src={Or} alt="" />
            </p>
            <div className="login-icons text-center ">
              <a href="./">
                <img src={Facebook} alt="" />
              </a>
              <a href="./">
                <img src={Google} alt="" />
              </a>
              <a href="./">
                <img src={Twitter} alt="" />
              </a>
            </div>
            <p className="text-footer mt-3 ">
              Don’t have an account?
              <Link to="/signup" className="click" href="click">
                Click here
              </Link>
            </p>
          </form>
        </section>
      </main>
      {/* <App user={user}/> */}
      {/* <ProtectedRoutes user={user}/> */}
    </>
  );
};

export { Login };
